module.exports = __webpack_public_path__ + "static/media/long-ad-festive.9bad375a.jpg";